module.exports = __webpack_public_path__ + "img/logo-352-full.15acf919.png";